export const filters = [
    {   
        component: 'datepicker-range',
        label: "Data de Criação",
        disabled: false,
        hidden: false,
        style: 'col -right form-sale-dates',
        dateStart: '01/01/2012',
        params: {
            name: 'created_at',
            value: null
        },
    },
    {
        component: 'datepicker-range',
        label: "Data de Atualização",
        disabled: false,
        hidden: false,
        style: 'col -right form-sale-dates',
        dateStart: '01/01/2012',
        params: {
            name: 'updated_at',
            value: null
        },
    },
    {
        component: 'datepicker-range',
        label: "Data de Venda",
        disabled: false,
        hidden: false,
        style: 'col -right form-sale-dates',
        dateStart: '01/01/2012',
        params: {
            name: 'saled_at',
            value: null
        },
    },

    {
        component: 'select-tags',
        label: "Origens",
        disabled: false,
        hidden: false,
        service: 'origins',
        method: 'getOrigins',
        itemLabel: 'label',
        searchAble: true,
        multiple: true,
        serviceParams: [],
        options: [],
        returnValue: 'id',
        params: {
            name: 'origin_id',
            value: null
        },
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
    },
    {
        component: 'select-tags',
        label: "Tags",
        disabled: false,
        hidden: false,
        service: 'tag',
        method: 'getTagOptions',
        itemLabel: 'label',
        searchAble: true,
        multiple: true,
        serviceParams: ['tags'],
        options: [],
        returnValue: 'label',
        params: {
            name: 'tags',
            value: null
        },
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
		openEvent: 'proposal-list-tags'
    },
    {
        component: 'select-tags',
        label: "Empreendimentos",
        disabled: false,
        hidden: false,
        service: 'product',
        itemLabel: 'label',
        searchAble: true,
        multiple: true,
        method: 'getProductOptions',
        options: [],
        returnValue: 'id',
        params: {
            name: 'product_id',
            value: null
        },
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
    },
    {
        component: 'select-tags',
        label: "Status",
        disabled: false,
        hidden: false,
        itemLabel: 'name',
        searchAble: false,
        multiple: true,
        options: [],
        returnValue: 'id',
        params: {
            name: 'funnel_stage_status_id',
            value: null
        },
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
    },
    {
        component: 'select-tags',
        label: "Responsável",
        disabled: false,
        hidden: false,
        itemLabel: 'item',
        searchAble: false,
        multiple: false,
        options: [
            { item: 'Todos', value: 'allDeals', id: 0 },
            { item: 'Meus Clientes', value: 'myDeals', id: 1 },
            { item: 'Acompanhando', value: 'followingDeals', id: 2 },
            { item: 'Não Atribuídos', value: 'notAssigned', id: 3 },
        ],
        returnValue: 'value',
        params: {
            name: 'owner',
            value: null
        },
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
    },
    {
        component: 'select-tags',
        label: "Equipe",
        disabled: false,
        hidden: false,
        handler: 'teamHandler',
        service: 'team',
        method: 'getAll',
        itemLabel: 'name',
        searchAble: true,
        multiple: false,
        serviceParams: ['', { nocover: true, per_page: 1000 }],
        options: [],
        returnValue: 'id',
        params: {
            name: 'team_id',
            value: null
        },
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
    },
    {
        component: 'select-tags',
        label: "Gerente",
        disabled: false,
        hidden: false,
        handler: 'managerHandler',
        itemLabel: 'first_name',
        searchAble: true,
        multiple: false,
        options: [],
        returnValue: 'manager_id',
        params: {
            name: 'manager_id',
            value: null
        },
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
    },
    {
        component: 'select-tags',
        label: "Corretor",
        disabled: false,
        hidden: false,
        itemLabel: 'first_name',
        searchAble: true,
        multiple: false,
        options: [],
        returnValue: 'broker_id',
        params: {
            name: 'broker_id',
            value: null
        },
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
    }
]

export const columns = [
    {
        title: 'Código',
        allowedExcept: []
    },
    {
        title: 'Cliente',
        data: 'customer_name',
        sortable: true,
        allowedExcept: [],
    },
    {
        title: 'CPF',
        allowedExcept: [],
    },
    {
        title: 'Empreendimento',
        data: 'product_name',
        sortable: false,
        allowedExcept: [],
    },
    {
        title: 'Valor',
        data: 'cost',
        sortable: true,
        allowedExcept: [],
    },
    {
        title: 'Responsável',
        data: 'user_name',
        sortable: true,
        allowedExcept: ['broker'],
    },
    {
        title: 'Etapa - Status',
        data: 'stage',
        sortable: true,
        allowedExcept: [],
    },
    {
        title: '',
        class: 'control-xs',
        allowedExcept: [],
    },
]